<template>
    <span v-if="tutorial" class="tutorial">
        <button type="button" class="tutorial__boton" :class="'tutorial__boton--' + variante" @click="abrir">
            <span class="tutorial__play"><v-icon small>play_arrow</v-icon></span>
            <span class="tutorial__textos">
                <span class="tutorial__titulo">{{ tutorial.titulo }}</span>
                <span class="tutorial__subtitulo">Ver el video tutorial</span>
            </span>
        </button>

        <v-dialog v-model="visible" max-width="920" content-class="tutorial__dialogo">
            <v-card color="#0e1326" dark>
                <v-card-title class="text-subtitle-1 font-weight-bold py-2">
                    {{ tutorial.titulo }}
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="visible = false" title="Cerrar"><v-icon>close</v-icon></v-btn>
                </v-card-title>

                <!-- El video solo existe mientras el diálogo está abierto: al cerrar deja de sonar. -->
                <div class="tutorial__marco">
                    <iframe
                        v-if="visible"
                        :src="`https://www.youtube-nocookie.com/embed/${tutorial.video_id}?autoplay=1&rel=0`"
                        :title="tutorial.titulo"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                    ></iframe>
                </div>

                <v-card-actions class="px-4">
                    <span class="text-caption" style="opacity: .7">¿No se ve el video?</span>
                    <a :href="tutorial.url" target="_blank" rel="noopener" class="tutorial__enlace ml-2">Abrirlo en YouTube</a>
                    <v-spacer></v-spacer>
                    <v-btn small text @click="visible = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
/**
 * Botón "ver tutorial" con el video de YouTube que se configura en
 * Administración → Centro Ayuda. Si no hay video activo, no muestra nada.
 *
 *   <tutorial-video variante="oscuro"/>   sobre el panel azul del ingreso
 *   <tutorial-video variante="claro"/>    sobre fondo blanco
 */
let consulta = null; // Una sola petición aunque el botón aparezca dos veces en la página.

export default {
    name: "TutorialVideo",
    props: {
        variante: {type: String, default: "claro"},
    },
    data() {
        return {tutorial: null, visible: false};
    },
    methods: {
        abrir() {
            this.visible = true;
        },
    },
    created() {
        consulta = consulta || window.axios.get("/ayuda").then(r => (r.data.success ? r.data.data.tutorial : null)).catch(() => null);
        consulta.then(tutorial => {
            this.tutorial = tutorial;
        });
    },
}
</script>

<style lang="scss" scoped>
.tutorial__boton {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    text-align: left;
    border-radius: 999px;
    padding: 7px 20px 7px 7px;
    cursor: pointer;
    transition: transform .15s ease, background .15s ease, box-shadow .15s ease;
    font-family: inherit;

    &:hover { transform: translateY(-1px); }
    &:focus-visible { outline: 2px solid #d29e4a; outline-offset: 3px; }

    &--oscuro {
        margin-bottom: 34px;
        background: rgba(255, 255, 255, .1);
        border: 1px solid rgba(255, 255, 255, .28);
        color: #fff;

        &:hover { background: rgba(255, 255, 255, .17); }
        .tutorial__subtitulo { color: rgba(255, 255, 255, .7); }
    }

    &--claro {
        background: #f3f5fb;
        border: 1px solid #dfe4f1;
        color: #1b2340;
        width: 100%;

        &:hover { background: #e9edf8; }
        .tutorial__subtitulo { color: #5b6380; }
    }
}

.tutorial__play {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #d29e4a;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;

    .v-icon { color: #1b2340; font-size: 24px; }
}

.tutorial__textos {
    display: flex;
    flex-direction: column;
    line-height: 1.25;
}

.tutorial__titulo {
    font-weight: 700;
    font-size: .95rem;
}

.tutorial__subtitulo {
    font-size: .78rem;
}

.tutorial__marco {
    position: relative;
    width: 100%;
    padding-top: 56.25%; // 16:9
    background: #000;

    iframe {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
    }
}

.tutorial__enlace {
    color: #e6bd7a;
    font-size: .8rem;
}

@media (prefers-reduced-motion: reduce) {
    .tutorial__boton { transition: none; }
    .tutorial__boton:hover { transform: none; }
}
</style>
